import React  from 'react';

import PrivacyPolicyContent from "../content/PrivacyPolicyContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

import { Helmet } from "react-helmet-async";

function PrivacyPolicy() {
    return(
        <>
        <Helmet>
            <title>Privacy Policy | Suvivah</title>

            <meta
                name="description"
                content="Read Suvivah's Privacy Policy to understand how we collect, use, protect, and safeguard your personal information while using our matrimonial services."
            />

            <meta
                name="keywords"
                content="Suvivah Privacy Policy, Privacy Policy, Data Protection, User Privacy, Matrimonial Privacy, Personal Information"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />

            <link rel="canonical" href="https://suvivah.org/privacy-policy" />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />
            <meta property="og:title" content="Privacy Policy | Suvivah" />
            <meta
                property="og:description"
                content="Learn how Suvivah collects, uses, and protects your personal information."
            />
            <meta property="og:url" content="https://suvivah.org/privacy-policy" />
            <meta
                property="og:image"
                content="https://suvivah.org/images/logo.png"
            />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Privacy Policy | Suvivah" />
            <meta
                name="twitter:description"
                content="Read Suvivah's Privacy Policy and learn how your information is protected."
            />
            <meta
                name="twitter:image"
                content="https://suvivah.org/images/logo.png"
            />
        </Helmet>

        <Navbar />
        <PrivacyPolicyContent/>
        <Footer />        
        </>
    );
}

export default PrivacyPolicy;